import { useMemo } from 'react';
import i18n from '../../../../../base-dictionary';
import { useThroughputTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setThroughputMetric } from '../../../../../store/strategy-store/strategy-store.actions';
import { MainSectionControls } from '../../components/main-section-controls/main-section-controls';
import { hasArrayData } from '../../initiative-performance.helpers';
import { ThroughputMode } from '../../initiative-performance.type';
import { useChartData as useContributingEpicsChartData } from './contributing-epics-chart/contributing-epics-chart.hooks';
import { useChartData as useContributingTeamsChartData } from './contributing-teams-chart/contributing-teams-chart.hooks';
import { useChartData as useInitiativeProgressChartData } from './initiative-progress-chart/initiative-progress-chart.hooks';
import { RefObject } from 'react';

type Props = {
  chartRef: RefObject<HTMLDivElement>;
};

export const MainSectionHeader = ({ chartRef }: Props) => {
  const mode = useThroughputTabStore((state) => state.mode);
  const metric = useThroughputTabStore((state) => state.metric);
  const selectedEpics = useThroughputTabStore((state) => state.selectedEpics);
  const selectedTeams = useThroughputTabStore((state) => state.selectedTeams);

  const initiativeProgressChartData = useInitiativeProgressChartData(metric);
  const contributingEpicsChartData = useContributingEpicsChartData();
  const contributingTeamsChartData = useContributingTeamsChartData();

  const hasData = useMemo(() => {
    switch (mode) {
      case ThroughputMode.InitiativeProgress:
        return hasArrayData(initiativeProgressChartData);
      case ThroughputMode.ContributingEpics:
        return hasArrayData(contributingEpicsChartData) && selectedEpics.length > 0;
      case ThroughputMode.ContributingTeams:
        return hasArrayData(contributingTeamsChartData) && selectedTeams.length > 0;
      default:
        return false;
    }
  }, [
    initiativeProgressChartData,
    contributingEpicsChartData,
    contributingTeamsChartData,
    mode,
    selectedEpics,
    selectedTeams,
  ]);

  const title = i18n.t('strategy.initiative_performance.throughput');

  return (
    <MainSectionControls
      title={title}
      chartRef={chartRef}
      metric={metric}
      setMetric={setThroughputMetric}
      disableControls={!hasData}
    />
  );
};
